import { render, staticRenderFns } from "./newobviateDefectsManage.vue?vue&type=template&id=8a574252&scoped=true&"
import script from "./newobviateDefectsManage.vue?vue&type=script&lang=js&"
export * from "./newobviateDefectsManage.vue?vue&type=script&lang=js&"
import style0 from "./newobviateDefectsManage.vue?vue&type=style&index=0&id=8a574252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a574252",
  null
  
)

export default component.exports